import React, { useState, useEffect, useContext } from 'react';
import { Breadcrumb, Col, Row } from "antd";
import Icofont from "react-icofont";
import { errorCatch, JSXMap, QueryOrder, READ, READWITH } from '../../components/Tool';
import { Link, Route, useRouteMatch } from "react-router-dom";
import { useUserContext } from '../../components/Context';
import { useAuth } from '../../components/Auth';

function ServiceView(props) {
    const { service } = props;
    if (!service) return <></>;
    return (
        <Col key={service.ID} className="gutter-row" span={8} style={{ paddingBottom: "25px" }}>
            <Link to={`${service.ID}`}>
                <div className={"service row3 s" + service.ID} style={{ padding: '8px 0' }}>
                    <div className="service-name">
                        <Icofont icon={service.icon} style={{ fontSize: "22px", paddingRight: "5px" }} />
                        <span>{service.name}</span>
                    </div>
                </div>
            </Link>
        </Col>
    );
}
export default function Services(props) {
    const auth = useAuth();
    const user = useUserContext();
    const [services, setServices] = useState();
    const [context, setContext] = useState();

    useEffect(() => {
        READWITH(auth, "Services",
            [
                QueryOrder("ID", "ASC")
            ],
            (res) => setServices(res.data),
            errorCatch
        );
        READ(auth, "Context",
            (res) => setContext(res.data),
            errorCatch
        );
    }, []);

    return (<>
        <div style={{ padding: "0 24px" }}>
            <Breadcrumb style={{ margin: '16px 0' }}>
                <Breadcrumb.Item>Сервисы</Breadcrumb.Item>
            </Breadcrumb>
        </div>
        <div className="site-layout-background" style={{ padding: 24, minHeight: 360, height:"100%" }}>
            <h2 style={{ textAlign: "center", padding: "15px 0px" }}>Экспертные знания о сельском хозяйстве - от выбора сорта до уборки урожая</h2>
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                {JSXMap(services, (e, idx) => <ServiceView key={idx} service={e} />)}
            </Row>
        </div>
    </>);
}